/**
 * User actions
 */
export const USER_SET = 'USER_SET';

export function userSet(payload) {
    return { type: USER_SET, payload };
};